import { useAtomValue } from 'jotai';
import { comparisonGameFiltersToPersistAtom, filtersToPersistAtom } from '@/atoms/filters/persistedFilters';
import {
  comparisonCompetitionIdsToFilterByAtom,
  comparisonSeasonIdsToFilterByAtom,
} from '@/atoms/filters/player/playerComparisonFilters';
import { playerComparisonEventsForMetricCountAtom } from '@/atoms/queries/player/playerEventDataComparison';
import { PlayerComparisonPreviewEvents } from '@/components/player/radar/preview/PlayerPreviewEventsComparison';
import { PlayerComparisonEventMap } from '@/components/player/vis/PlayerEventMapComparison';
import { EntityMetricPreviewPanel } from '@/components/preview/EntityMetricPreviewPanel';
import { COMPARISON_ID } from '@/consts/searchKeys';
import { useQueryParam } from '@/hooks/useQueryParam';

export const PlayerComparisonPreviewPanel = () => {
  const comparisonId = useQueryParam(COMPARISON_ID);
  const filters = useAtomValue(filtersToPersistAtom);
  const comparisonGameFilters = useAtomValue(comparisonGameFiltersToPersistAtom);
  const comparisonCompetitionIds = useAtomValue(comparisonCompetitionIdsToFilterByAtom);
  const comparisonSeasonIds = useAtomValue(comparisonSeasonIdsToFilterByAtom);
  const comparisonFilters = {
    ...filters,
    ...comparisonGameFilters,
    competitionIds: comparisonCompetitionIds,
    seasonIds: comparisonSeasonIds,
  };

  return (
    <EntityMetricPreviewPanel
      pathTo={comparisonId ? `../../../player/${comparisonId}/vis` : undefined}
      eventsForMetricCountAtom={playerComparisonEventsForMetricCountAtom}
      filtersToHydrate={comparisonFilters}
      eventMap={<PlayerComparisonEventMap isPreview />}
    >
      <PlayerComparisonPreviewEvents />
    </EntityMetricPreviewPanel>
  );
};
